import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useQuestionLibraryStore } from '../store/questionLibraryStore';

/**
 * @function useIsFocused hook - checks if the question is focused
 * @param {string} questionName - The name of the question
 * @returns {boolean}
 */
export const useIsFocused = (questionName) => {
  const focusedQuestion = useQuestionLibraryStore((s) => s.focusedQuestion);

  return useMemo(() => {
    if (!questionName) {
      return false;
    }
    return focusedQuestion === questionName;
  }, [focusedQuestion, questionName]);
};

export function useSelectSmartAnswer(questionName) {
  return useQuestionLibraryStore(
    useShallow((s) => s.screenData.questionAnswers?.[questionName]),
  );
}
